export default "__VITE_ASSET__914498f4__"